import React from "react";
import '../styles/Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      person: "Girish Nair",
      company: "Bosch Spare Parts Division",
      feedback:
        "We are pleased to commend M/s PMJ Logistics for their exemplary performance as our third-party logistics partner in Bosch spare parts management. Their advanced warehousing capabilities and efficient distribution services have consistently ensured smooth operations and reliable part availability throughout our network. The professionalism and attention to detail displayed by their team have played a critical role in optimizing our supply chain. We highly value this partnership and confidently endorse PMJ Logistics for their commitment to operational excellence and customer satisfaction.",
    },
    {
      person: "Deepak Kakade",
      company: "Kirloskar Ferrous Industries Ltd",
      feedback:
        "PMJ Logistics Solutions has been a reliable partner for our supply chain. Deliveries are always on time and well-coordinated. The team is proactive, professional, and always ready to support us even during urgent requirements. With PMJ’s support, we have been able to reduce costs and improve efficiency in our operations. We value our partnership with PMJ Logistics Solutions and highly recommend their services.",
    },
  ];

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <h2>Testimonials</h2>
        <div className="testimonials-grid">
          {testimonials.map((t, i) => (
            <div key={i} className="testimonial-card">
              <p className="testimonial-feedback">“{t.feedback}”</p>
              <h4 className="testimonial-name">– {t.person}</h4>
              <p className="testimonial-company">{t.company}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
